var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.preSaleActive
    ? _c(
        "div",
        {
          staticClass: "bandana-v7-teaser position-relative",
          staticStyle: {
            background:
              "repeat center center url('https://img.fortawesome.com/1ce05b4b/tablecloth-pattern3.png'),linear-gradient(135deg, var(--fa-yellow), var(--fa-dk-yellow))",
            overflow: "hidden",
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row roomy" }, [
              _c(
                "div",
                {
                  staticClass:
                    "column-12 padding-y-xl padding-x-0 margin-left-xl tablet:margin-left-0",
                },
                [
                  _c("div", { staticClass: "display-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "column-1 align-middle align-center display-flex",
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.$v6.solid.faCircle7, size: "2x" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "column-11 tablet:display-flex align-between align-middle",
                        staticStyle: { "--button-margin-bottom": "0" },
                      },
                      [
                        _c("div", [
                          _c(
                            "h2",
                            {
                              staticClass: "h4 margin-top-0 margin-bottom-4xs",
                            },
                            [_vm._v("Introducing Font Awesome 7!")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "padding-right-2xl tablet:padding-right-0",
                            },
                            [
                              _vm._v(
                                "\n                Coming in June 2025.\n                "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "link flat",
                                  staticStyle: {
                                    "--button-padding": "0",
                                    "--button-color": "var(--fa-navy)",
                                    "--button-hover-color": "var(--fa-dk-blue)",
                                    "--button-decoration": "underline",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit("show-livestream-modal")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  Watch the Announcement\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "margin-top-lg tablet:margin-top-0" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "button flat with-border",
                                staticStyle: {
                                  "--button-color": "var(--fa-navy)",
                                  "--border-color": "var(--fa-dk-yellow)",
                                  "--button-background": "var(--fa-yellow)",
                                  "--button-hover-background":
                                    "var(--fa-dk-yellow)",
                                },
                                attrs: { href: "/#fa7" },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "padding-right-xs",
                                  attrs: {
                                    icon: _vm.$v6.solid.faSparkles,
                                    size: "lg",
                                  },
                                }),
                                _vm._v("See What's New\n              "),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                staticClass: "button flat with-border",
                                staticStyle: {
                                  "--button-color": "var(--fa-navy)",
                                  "--border-color": "var(--fa-dk-yellow)",
                                  "--button-background": "var(--fa-yellow)",
                                  "--button-hover-background":
                                    "var(--fa-dk-yellow)",
                                },
                                attrs: { to: { name: "plans" } },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "padding-right-xs",
                                  attrs: {
                                    icon: _vm.$v6.solid.faTag,
                                    size: "lg",
                                  },
                                }),
                                _vm._v(
                                  _vm._s(_vm.daysLeft) +
                                    " " +
                                    _vm._s(
                                      _vm.formatPlural(_vm.daysLeft, "Day")
                                    ) +
                                    " Left to Save!\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }